import { ChangeDetectionStrategy, Component, OnInit, QueryList, ViewChild, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { RetrievalService } from '../retrieval/retrieval.service';
import { DocumentMetaData,  RetrievalSearchFields, RetrievalSearchResults, SearchField } from '../../models/search-field';
import { BusinessArea, DocumentType } from '../../models/model';
import { ConstraintsModel, dateConstraints, dateMatchModes, GridColumnHeader, MatchModeOptionsModel, textNumberConstraints, textNumberMatchModes } from '../../models/grid-column-header';
import { GlobalService } from '../../services/global.service';
import { SaveColumnsReorder } from '../../models/save-Columns-Reorder';
import { CommonService } from '../../services/common.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSelectChange } from '@angular/material/select';
import { DocumentHistoryDialogComponent } from '../../shared/document-history-dialog/document-history-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DocumentHistoryResponse } from '../../models/document-history.model';
import { WorkflowHistoryDialogComponent } from '../../shared/workflow-history-dialog/workflow-history-dialog.component';
import { WorkflowHistoryResponse } from '../../models/workflow-history.model';
import { DialogComponent, DialogData } from '../../shared/dialog/dialog.component';
import { SendEmailComponent } from '../../shared/send-email/send-email.component';
import { ViewAddDocNotesComponent } from '../../shared/view-add-doc-notes/view-add-doc-notes.component';
import { ViewWorkflowNotesComponent } from '../../shared/view-workflow-notes/view-workflow-notes.component';
import { environment } from '../../../environments/environment';
import { DynamicDateAdapter } from '../../common/dynamic-date-adapter';
import { DateAdapter } from '@angular/material/core';
import moment from 'moment';
import { AppContext } from '../../models/appContext';
import { LineItemsGlEntryComponent } from '../../shared/line-items-gl-entry/line-items-gl-entry.component';
import { userPreference } from '../../common/tabs.constant';
import { DateService } from '../../services/date.service';
import { UserSystemPreference } from '../../models/userSystemPreference';

@Component({
  selector: 'app-retrieval',
  templateUrl: './retrieval.component.html',
  styleUrls: ['./retrieval.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetrievalComponent implements OnInit {
  isGridLoaded = false;
  disableOtherButtons = true;
  disableDeleteButtons = true;
  enableViewSelectedButton = false;
  userInfo: any;
  BuisnessAreaList: BusinessArea[] = [];
  selectedBusinessArea: any;
  allSearchFields: SearchField[] = [];
  searchFields: SearchField[] = [];
  searchForm: FormGroup;
  retrievalSearchFields?: RetrievalSearchFields;
  retrievalSearchResults?: RetrievalSearchResults;
  gridColumnHeaderValues?: GridColumnHeader[];
  columns: GridColumnHeader[] = [];
  businessAreaList: BusinessArea[] = [];
  documentTypes: DocumentType[] = [];
  selectedDocumentType!: number;
  selectedDocTypeName!: string;
  public workItems: DocumentMetaData[] = [];
  public data: DocumentMetaData[] = [];
  public selectedWorkItems: any[] = [];
  public saveColumnReorderDto: any;
  public isSearchFieldsLoading: boolean = false;
  @ViewChild('searchResultsPanel') searchResultsPanel: MatExpansionPanel | undefined;
  isDeleteDisabled: boolean = true;
  isExportDisabled: boolean = true;
  public gridColumns: GridColumnHeader[] = [];
  public errorMessage: string = '';
  filters: { [key: string]: any } = {};
  sortField: string = "";
  sortOrder: number = 1;
  isDataAvailable: boolean = false;
  hasSearched: boolean = false;
  isBusinessAreaLoading: boolean = true;
  isTableLoading: boolean = true;
  totalRecords: number = 0;
  hideDelete=false;
  rowsOptions = [ 
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '75', value: 75 },
    { label: '100', value: 100 },
    { label: '200', value: 200 },
    { label: '300', value: 300 },
    { label: '500', value: 500 },
    { label: 'All', value: 0 }  
  ];
  dragSelecting = false;
  selectedIndexes: number[] = []; 
  rows: number = 25;
  pageNo: number = 0;
  pagesToHoldData: number = 0;
  userPreferedDateformat!:string |null;
  userPreferedDateTimeformat!:string |null;
  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;

  ngAfterViewInit(): void {
    // Wait for view to fully initialize and then open the first panel
    setTimeout(() => {
      const firstPanel = this.panels.first;
      if (firstPanel) {
        firstPanel.open();
      }
    });
  }

  constructor(
    private readonly fb: FormBuilder,
    private readonly retrievalService: RetrievalService,
    private readonly commonService: CommonService,
    private readonly globalVariable: GlobalService,
    private readonly dialog: MatDialog,
    private readonly cd: ChangeDetectorRef,
    private readonly dateAdapter: DateAdapter<any>,
    private readonly dateService:DateService
  ) {
    this.searchForm = this.fb.group({
      searchFields: this.fb.array([])
    });
  }

  async ngOnInit() {
    this.commonService.clearMessage();
    AppContext.userDetails = this.globalVariable.getUserDetails;
    this.hideDelete = AppContext.userDetails.highestSecurityTypeName == "FullAccess" ? true:false;
    await this.callRegisterPrincipal(Number(this.globalVariable.getSelectedSystemId));
    this.getBusinessAreas();
  }

  callRegisterPrincipal(systemId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.commonService.callRegisterPrincipal(systemId).subscribe({
        next: (response) => {
          resolve();
        },
        error: (error) => {
          this.commonService.openErrorDialog(error.error.message);
          this.commonService.showMessage('User registration failed', 'error');
          reject(error);
        }
      });
    });
  }

  onRowsChange(event: Event) {
    this.selectedIndexes = [];
    this.syncSelectedWorkItems();
    const target = event.target as HTMLSelectElement;
    const selectedValue = Number(target.value);
    this.rows = selectedValue === 0 ? this.workItems.length : selectedValue;
  } 

  getMomentFormat(field: SearchField): string {
    let rawFormat = field.fieldDateFormat?.defaultFormat || 'dd/MM/yyyy HH:mm:ss';
    rawFormat = this.dateService.cleanFormat(rawFormat);
    return this.dateService.toMomentFormat(rawFormat);
  }

  formatDate(date: Date, field: SearchField): string {
    const momentFormat = this.getMomentFormat(field);
    return moment(date).format(momentFormat);
  }


  onRangePickerOpened(index: number): void {
    const field = this.searchFields[index];
    const momentFormat = this.getMomentFormat(field);
    const culture = field.fieldDateFormat?.cultureName;
    if (this.dateAdapter instanceof DynamicDateAdapter) {
      this.dateAdapter.setDynamicFormat(momentFormat);
      this.dateAdapter.setDynamicLocale(culture!);
    }
  }

  onRangeDateChange(event: any, index: number, type: 'start' | 'end'): void {
    const selectedDate: Date = event.value;
    if (!selectedDate) return;
    this.onRangePickerOpened(index);
  }

  getDatePlaceholder(index: number, type: 'start' | 'end'): string {
    const format = this.dateService.cleanFormat(this.searchFields[index]?.fieldDateFormat?.defaultFormat || 'dd/MM/yyyy');
    const displayFormat = format?.split(' ')[0] || 'DD/MM/YYYY';
    return type === 'start' ? `From date ${displayFormat}` : `To date ${displayFormat}`;
  }

  // Function to toggle the expansion panel
  togglePanel(panel?: MatExpansionPanel) {
    panel?.toggle();
  }

  // Function to get the search fields array from the form
  get searchFieldsArray(): FormArray {
    return this.searchForm.get('searchFields') as FormArray;
  }

  // Function to get the business areas
  getBusinessAreas(): void {
    this.isBusinessAreaLoading = true;
    this.retrievalService.getBusinessAreaList(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId).subscribe({
      next: (response: BusinessArea[]) => {
        this.businessAreaList = response;
        this.isBusinessAreaLoading = false;
        if (response.length === 1) {
          this.selectedBusinessArea = response[0].id;
          this.isSearchFieldsLoading = true;
          this.getSearchFields();
        }
        this.cd.detectChanges();
      },
      error: () => {
        console.error('Not able to fetch the bussiness aread');
        this.isBusinessAreaLoading = true;
      }
    });
  }

  // Function to get the document types based on the selected business area
  getDocumentTypesBasedOnBusinessArea(event: MatSelectChange): void {
    this.selectedWorkItems = [];
    this.updateButtonStates();
    if (this.selectedBusinessArea) {
      this.isSearchFieldsLoading = true;
      this.getSearchFields();
    }
  }

  // Function to get the search fields based on the selected business area
  getSearchFields(): void {
    this.retrievalService.getSearchFields(
      this.globalVariable.getUserGPID,
      this.globalVariable.getSelectedSystemId,
      this.selectedBusinessArea).subscribe({
        next: (response: SearchField[]) => {
          this.allSearchFields = response;
          this.searchFields = response.filter(field => field.columnName !== 'HOLD_REASON' && field.columnName !== 'TOTAL_TAX_AMOUNT');
          this.setUpSearchFields();
          this.isSearchFieldsLoading = false;
          this.cd.detectChanges();
          this.getUserPreferences();
        },
        error: (error) => {
          this.isSearchFieldsLoading = false;
          console.error('Error fetching search fields:', error);
        }
      });
  }

  getUserPreferences(): void {
    if(this.globalVariable.getUserPreferences.length !== 0){ 
      this.globalVariable.getUserPreferences.forEach((item)=>{
        if (item.preferenceTitle ==  userPreference.DateFormatDisplay) {
          this.userPreferedDateTimeformat = item.dateFormatOptions[0].defaultFormat;
          this.userPreferedDateformat = item.dateFormatOptions[0].defaultFormat.split(' ')[0];
        }
      });
    } else {
      this.commonService.getUserPerferences().subscribe({
        next: (response: UserSystemPreference[]) => { 
          this.globalVariable.setUserPreferences = response; 
          response.forEach((item)=>{
            if (item.preferenceTitle ==  userPreference.DateFormatDisplay) {
              this.userPreferedDateTimeformat = item.dateFormatOptions[0].defaultFormat;
              this.userPreferedDateformat = item.dateFormatOptions[0].defaultFormat.split(' ')[0];
            }
          });
        },
        error: (error) => {
          this.commonService.showMessage('Error in loading user preferences.','error');
        },
      });
    } 
  }

  // Function to set up the search fields in the form
  setUpSearchFields(): void {
    const controls = this.searchFields.map(field => {
      if (field.controlName == "DATE") {
        let startDate: Date | null = null;
        let endDate: Date | null = null;
        if (field.columnName == "CREATE_DATE") {
          endDate = new Date();
          startDate = new Date();
          startDate.setMonth(startDate.getMonth() - 3);

          const momentFormat = this.getMomentFormat(field);
          const culture = field.fieldDateFormat?.cultureName;
          if (this.dateAdapter instanceof DynamicDateAdapter) {
            this.dateAdapter.setDynamicFormat(momentFormat);
            if (culture) {
              this.dateAdapter.setDynamicLocale(culture);
            }
          }
        }
        return this.fb.group({
          value: [field.inputValues || ''],
          filter: [field.selectedSearchOperator || '1'],
          [`startDate${field.columnName}`]: [startDate],
          [`endDate${field.columnName}`]: [endDate]
        });
      }
      if (field.controlName === "CHECK_BOX") {
        return this.fb.group({
          yes: [field.inputValue === '1'],
          no: [field.inputValue === '0'],
        });
      }
      const defaultFilter = field.controlName === "COMBO_BOX" && field.isComboMultiSelect ? '4' : '3';
      return this.fb.group({
        value: [field.inputValues || ''],
        filter: [field.selectedSearchOperator || defaultFilter] 
      });
    });
    this.searchFieldsArray.clear();
    controls.forEach(control => this.searchFieldsArray.push(control));
  }

  openDocument(url: string, event: MouseEvent) {
    event.preventDefault();
    const tabName = 'document_tab_' + btoa(encodeURIComponent(url)); // unique per URL
    const win = window.open(url, tabName);
    if (win) {
      win.focus();
    }
  }

  handleRightClick(event: MouseEvent) {
    event.preventDefault();
    this.commonService.openErrorDialog('Right click is disabled for this action. Please navigate using left mouse click.');
  }

  // Function to Submit the search form
  onSubmit(PageNumber: number): void {
    this.retrievalSearchResults = undefined;
    this.workItems = [];
    this.totalRecords = 0;
    this.data = [];
    this.selectedWorkItems = [];
    this.isDataAvailable = true;
    this.isTableLoading = true;
    this.getGridColumns();
    this.updateButtonStates();
    if (this.searchForm.invalid) {
      return;
    }
    const formValue = this.searchForm.value;
    const formattedData = this.allSearchFields.map((field) => {
      const fieldControl = this.getSearchFieldControl(field, formValue.searchFields);
      this.applySearchFieldValue(field, fieldControl);
      const inputValue = this.getNormalizedInputValue(field, fieldControl);

      return {
        fieldOrder: field.fieldOrder,
        controlType: field.controlType,
        controlName: field.controlName,
        displayName: field.displayName,
        tableName: field.tableName,
        id: field.id,
        columnName: field.columnName,
        inputValue: inputValue,
        inputValues: field.inputValues || [],
        comboValues: field.comboValues || [],
        selectedSearchOperator: fieldControl.filter || 3,
        fieldDataType: field.fieldDataType,
        fieldComboRefId: field.fieldComboRefId,
        searchOperatorOptions: field.searchOperatorOptions,
        customSearchOperatorOptions: field.customSearchOperatorOptions,
        fieldDateFormat: field.fieldDateFormat,
        userPrefFieldOrder: field.userPrefFieldOrder,
        isComboOnDemand: field.isComboOnDemand,
        vmdLookUpField: field.vmdLookUpField,
        doctypeId: field.doctypeId,
        isComboMultiSelect: field.isComboMultiSelect
      };
    });
    this.retrievalSearchFields = {
      documentClass: 'ImageVision',
      pageNum: PageNumber,
      searchFields: formattedData,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      userGpid: this.globalVariable.getUserGPID,
      vendorCode: this.globalVariable.getUserVendorCode,
      businessAreaId: this.selectedBusinessArea
    };
    this.getSearchResults();
  }

  private getSearchFieldControl(field: SearchField, formFields: any[]): any {
    const displayIndex = this.searchFields.findIndex(d => d.id === field.id);
    if (displayIndex === -1) {
      return { value: '', filter: field.selectedSearchOperator || 3 };
    }

    return formFields[displayIndex];
  }

  private applySearchFieldValue(field: SearchField, fieldControl: any): void {
    if (field.controlName === 'DATE') {
      this.applyDateFieldValue(field, fieldControl);
      return;
    }

    if (field.controlName === 'CHECK_BOX') {
      this.applyCheckboxFieldValue(fieldControl);
    }
  }

  private applyDateFieldValue(field: SearchField, fieldControl: any): void {
    if (!fieldControl) {
      fieldControl = { value: '' };
    }

    const startDate = fieldControl['startDate' + field.columnName];
    const endDate = fieldControl['endDate' + field.columnName];
    if (startDate && endDate) {
      fieldControl.value = this.formatDate(startDate, field) + ',' + this.formatDate(endDate, field);
      return;
    }

    if (startDate || endDate) {
      const formattedStart = startDate ? this.formatDate(startDate, field) : '';
      const formattedEnd = endDate ? this.formatDate(endDate, field) : '';
      fieldControl.value = formattedStart + ',' + formattedEnd;
      return;
    }

    fieldControl.value = '';
  }

  private applyCheckboxFieldValue(fieldControl: any): void {
    if (!fieldControl) {
      fieldControl = { value: '' };
    }

    if (fieldControl.yes) {
      fieldControl.value = 'true';
      return;
    }

    if (fieldControl.no) {
      fieldControl.value = 'false';
      return;
    }

    fieldControl.value = '';
  }

  private getNormalizedInputValue(field: SearchField, fieldControl: any): string {
    const rawValue = fieldControl?.value ?? '';
    let inputValue: string;

    if (rawValue.length === 0) {
      inputValue = '';
    } else if (Array.isArray(rawValue)) {
      inputValue = rawValue.join(', ');
    } else {
      inputValue = rawValue;
    }

    if (['TOTAL', 'APPROVED_AMOUNT', 'TOTAL_NET_AMOUNT'].includes(field.columnName)) {
      inputValue = inputValue.replace(/,/g, '.').replace(/;/g, ',');
    }

    return inputValue;
  }

  // Funtion to reset the form
  resetForm() {
    if (!this.searchFieldsArray || !Array.isArray(this.searchFieldsArray.controls) || this.searchFieldsArray.length === 0) {
      return;
    }

    this.hasSearched = false;
    this.isDataAvailable = false;
    this.retrievalSearchResults = undefined;
    this.workItems = [];
    this.totalRecords = 0;
    this.data = [];
    this.selectedWorkItems = [];
    this.searchFieldsArray.controls.forEach((control, index) => {
      const field = this.searchFields[index];
      if (field.controlName === 'DATE') {
        const columnName = field.columnName;
        control.patchValue({
          [`startDate${columnName}`]: null,
          [`endDate${columnName}`]: null,
          value: '',
          filter: field.searchOperatorOptions ? Object.keys(field.searchOperatorOptions)[0] : 3
        });
      } else if (field.controlName === 'CHECK_BOX') {
        control.patchValue({
          yes: false,
          no: false
        });
      } else {
        let filterValue: string | number;

        if (field.searchOperatorOptions && field.searchOperatorOptions[3]) {
          filterValue = '3';
        } else if (field.searchOperatorOptions) {
          filterValue = Object.keys(field.searchOperatorOptions)[0];
        } else {
          filterValue = 3;
        }

        control.patchValue({
          value: '',
          filter: filterValue
        });
      }
      //Mark controls as pristine and untouched
      control.markAsPristine();
      control.markAsUntouched();
    });
    //Reset form state
    this.searchForm.markAsPristine();
    this.searchForm.markAsUntouched();
    this.searchForm.updateValueAndValidity();
  }


  // Function to get the search results based on the search fields
  getSearchResults(): void {
    this.commonService.showMessage("Retrieval in progress....", "success");
    if (this.retrievalSearchFields!.pageNum == 0) { this.togglePanel(this.searchResultsPanel); }
    this.retrievalService.getSearchResults(this.retrievalSearchFields).subscribe({
      next: (response: RetrievalSearchResults) => {
        this.hasSearched = true;
        if (response.results.documentMetaDataList.length > 0) {
          this.isGridLoaded = true;
          this.isDataAvailable = true;
          this.retrievalSearchResults = response;
          response.results.documentMetaDataList = this.processSearchResponse(response.results.documentMetaDataList);
          this.workItems = this.totalRecords == 0 ? response.results.documentMetaDataList : [...this.workItems, ...response.results.documentMetaDataList];
          this.totalRecords = this.totalRecords == 0 ? response?.results?.documentMetaDataList?.length : (this.totalRecords + response?.results?.documentMetaDataList?.length);
          this.data = this.totalRecords == 0 ? response.results.documentMetaDataList : [...this.data, ...response.results.documentMetaDataList];
          this.generateFilters();
          this.customFilter();
        } 
        else if(!response.hasMoreItems && response.currentPage > 0){
          this.commonService.showMessage("No More records to show.","success");
        }
        else { 
          this.isDataAvailable = false;
        }
        this.isTableLoading = false;
        this.commonService.showMessage("Retrieval complete for the search criteria.","success");
        setTimeout(() => {
          if(this.retrievalSearchFields!.pageNum > 0){
            this.pageNo = this.pagesToHoldData;
          } 
        }, 10);
        this.cd.detectChanges();
      },
      error: (error) => {
        this.isDataAvailable = false;
        this.commonService.showMessage("Error in retrieving search results", "error");
        this.commonService.openErrorDialog(error.error.message);
        this.isTableLoading = false;
      }
    });
  }

  processSearchResponse(DocumentMetaDataList: DocumentMetaData[]): DocumentMetaData[] {
    DocumentMetaDataList.forEach((item) => {
      item.View_Document = `/documentViewer/0/${item.DOCUMENT_ID}/1/003/${item.BATCH_ID}`;
      item.ddrLink = `${environment.siteUrl}/DDR/DirectDocumentRetrieval.html?sys_id=${this.globalVariable.getSelectedSystemId}&doc_id=${item.DOCUMENT_ID}`;
       // Remove time part from DATE fields except CREATE_DATE
      for (const key in item) {
        if ( key.includes('DATE') ) {
          if(key !== 'CREATE_DATE'){
            item[key] = item[key] ? this.dateService.formatDateValue(item[key], this.userPreferedDateformat): '';
          } else { 
            item[key] = item[key] ? this.dateService.formatDateValue(item[key], this.userPreferedDateTimeformat): '';
          }
        }
      }
    });
    return DocumentMetaDataList;
  }

  // Function to handle page change event
  onPageChange(event: any) {
    const currentPage = Math.ceil(event.first / event.rows) + 1;
    const rowsPerPage = event.rows;
    const totalPages = Math.ceil(this.totalRecords / rowsPerPage);
    const isLastPage = (currentPage === totalPages - 1) || (currentPage === totalPages);
    if (isLastPage) {
      this.pagesToHoldData = event.first;
      this.retrievalSearchFields!.pageNum = this.retrievalSearchFields!.pageNum + 1;
      this.getSearchResults();
    }
  }

  // Function to get the grid columns
  getGridColumns(): void {
    this.retrievalService.getGridColumnHeaders(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId,
      "3", this.selectedBusinessArea, "0", "0"
    ).subscribe({
      next: (response: GridColumnHeader[]) => {
        this.gridColumnHeaderValues = response.map((column)=>
        {
          let matchModeOptionslist: MatchModeOptionsModel[] = [];
          let constraintslist: ConstraintsModel[] = [];

            switch (column.type) {
              case 'string':
              case 'number':
                matchModeOptionslist = [...textNumberMatchModes];
                constraintslist = textNumberConstraints.map(c => ({ ...c }));
                break;
              case 'date':
                matchModeOptionslist = [...dateMatchModes];
                constraintslist = dateConstraints.map(c => ({ ...c }));
                break;
              default:
                matchModeOptionslist = [];
                constraintslist = [];
            }
          return {
            ...column,
            advancefilter:  {
              matchModeOptions : matchModeOptionslist,
              operator: 'and',
              constraints: constraintslist,
              isAdvanceFilterUsed:false,
            }
          }
        });
        this.gridColumnHeaderValues.push({
          field: 'ddrLink',
          title: 'DDR Link',
          type: 'hyperlink',
          order: this.gridColumnHeaderValues.length + 1,
          width: '120px',
          required: false,
          selectedValues: [],
          filterOptions: [],
          advancefilter: {
            matchModeOptions: [],
            operator: 'and',
            constraints: [],
            isAdvanceFilterUsed: false,
          }
        });
        [...this.columns].sort((a, b) => a.order - b.order);
        this.columns = this.gridColumnHeaderValues;
      },
      error: (error) => { 
        this.errorMessage = 'Error fetching grid columns';
      }
    });
  }

  // Function to generate filters for the columns
  generateFilters() {
    this.columns.forEach(column => {
      if (column.field == 'View_Document') {
        column.filterOptions = [];
        column.selectedValues = [];
        return;
      }
      if (column.type == 'date') {
        column.filterOptions = [
          { label: 'Past 7 days', value: '7' },
          { label: 'Past 14 days', value: '14' },
          { label: 'Past 1 month', value: '30' },
          { label: 'Past 2 months', value: '60' },
          { label: 'Past 3 months', value: '90' },
          { label: 'Past 6 months', value: '182' },
          { label: 'Last year', value: '365' },
          { label: 'All', value: 'All' }
        ];
        column.selectedValues = [];
      } else {
        const values = new Set<string>();
        this.data.forEach(record => {
          const propertyName: keyof DocumentMetaData = column.field as keyof DocumentMetaData;
          const value = record[propertyName];
          if (value !== null && value !== undefined) {
            values.add(value);
          }
        }
        );
        column.filterOptions = Array.from(values).map(v => ({ label: v, value: v }));
        column.selectedValues = [];
      }
    });
  }

  copyToClipboard(value: any) {
    if (value !== null && value !== undefined) {
      navigator.clipboard.writeText(value.toString());
      this.commonService.showMessage('Value copied to clipboard.', 'success');
    }
  }

  onRowClick(event: MouseEvent, index: number): void {
    this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
  }

  toggleRowSelection(index: number, ctrlKey: boolean, shiftKey: boolean) {
    if (!ctrlKey && !shiftKey) { 
      this.selectedIndexes = [index];
    }
    else{
      const alreadySelected = this.selectedIndexes.includes(index);
      if (!alreadySelected) {
        this.selectedIndexes.push(index);
      }
      else {
        this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
      }
    } 
    this.syncSelectedWorkItems();
  }

  onRowKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
    }
  }

  onRowFocus(_event: FocusEvent, _index: number): void {
  }

  onMouseDown(event: MouseEvent,index: number) { 
    const ctrlKey = event.ctrlKey || event.metaKey;
    const shiftKey = event.shiftKey;
    if (event.button === 0 && !ctrlKey && !shiftKey) { 
      this.dragSelecting = true;
      this.selectedIndexes = [index];
      this.syncSelectedWorkItems();
      event.preventDefault();
    } 
  }

  onMouseOver(event: MouseEvent, index: number) {
    if (event.button === 0 && this.dragSelecting && !this.selectedIndexes.includes(index)) {
      this.selectedIndexes.push(index);
      this.syncSelectedWorkItems();
    }
  }

  onMouseUp() {
    if (this.dragSelecting) {
      this.dragSelecting = false;
    } 
  } 

  syncSelectedWorkItems() {
    this.selectedWorkItems = this.selectedIndexes
      .filter(i => i >= 0 && i < this.workItems.length)
      .map(i => this.workItems[i]); 
      this.updateButtonStates();
  }

  isSelected(index: number): boolean {
    return this.selectedIndexes.includes(index);
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }

  // Function to update the button states based on the selected work items
  updateButtonStates(): void {
    const count = this.selectedWorkItems?.length || 0;
    if (count === 0) {
      this.disableOtherButtons = true;
      this.disableDeleteButtons=  true;
      this.enableViewSelectedButton = false;
    } else if (count === 1) {
      this.disableOtherButtons = false;
      this.disableDeleteButtons=  false;
      this.enableViewSelectedButton = false;
    } else {
      this.disableOtherButtons = true;
      this.disableDeleteButtons=  false;
      this.enableViewSelectedButton = true;
    }
  }

  //Function to handle column reorder event
  onColumnReordered(event: any) {
    let columnReordered: any[] = [];
    this.columns = this.columns.map((col, index) => ({
      ...col,
      Order: index + 1
    }));
    this.columns.forEach((col) => {
      columnReordered.push(col.title);
    });
    let reOderedDisplayname = columnReordered.join(" | ");
    this.saveColumnReorderDto = new SaveColumnsReorder();
    this.saveColumnReorderDto.userName = this.globalVariable.getUserGPID;
    this.saveColumnReorderDto.businessAreaId = this.selectedBusinessArea;
    this.saveColumnReorderDto.fieldOrder = 0;
    this.saveColumnReorderDto.gridType = 3; // Retrieval grid type
    this.saveColumnReorderDto.displayName = reOderedDisplayname;
    this.saveColumnReorderDto.wfQueueId = 0;
    this.saveColumnReorderDto.workFlowId = 0;
    this.saveColumnReorderDto.systemId = Number(this.globalVariable.getSelectedSystemId);
    this.commonService.saveUserPreferencesColumns(this.saveColumnReorderDto, 0, this.globalVariable.getUserGPID, Number(this.globalVariable.getSelectedSystemId)).subscribe({
      next: (response) => {
        if (response) {
          this.commonService.showMessage("Saved reordered column for user " + this.globalVariable.getUserGPID, "success");
        }
      },
      error: (error) => {
        this.commonService.showMessage("Error: " + error.error.message + " - Unable to save reordered column for user " + this.globalVariable.getUserGPID + ".", "error");
      }
    });
  }

  // Function to handle custom filter event
  customFilter(value?: any) {
    this.selectedIndexes=[];
    this.syncSelectedWorkItems();
    let filteredData = [...this.data];
    if (Object.keys(this.filters).length) {
      Object.keys(this.filters).forEach((field) => {
        const selectedValues = this.filters[field];
        if (!selectedValues || selectedValues.length === 0)
          return;

        if (value === 'date') {
          if (selectedValues.includes('All'))
            return;

          const today = new Date();
          filteredData = filteredData.filter((workItem) => {
            const rawValue = workItem[field as keyof DocumentMetaData];
            if (!rawValue)
              return false;

            const itemDate = this.parseCustomDate(rawValue);

            if (!itemDate)
              return false;

            if (isNaN(itemDate.getTime()))
              return false;

            return selectedValues.some((selectedRange: any) => {
              if (selectedRange === '365') {
                const start = new Date(today.getFullYear() - 1, 0, 1);
                const end = new Date(today.getFullYear(), 0, 1);
                return itemDate >= start && itemDate < end;
              }

              let filterDate = new Date(today);
              switch (selectedRange) {
                case '7':
                  filterDate.setDate(today.getDate() - 7);
                  break;
                case '14':
                  filterDate.setDate(today.getDate() - 14);
                  break;
                case '30':
                  filterDate.setMonth(today.getMonth() - 1);
                  break;
                case '60':
                  filterDate.setMonth(today.getMonth() - 2);
                  break;
                case '90':
                  filterDate.setMonth(today.getMonth() - 3);
                  break;
                case '182':
                  filterDate.setMonth(today.getMonth() - 6);
                  break;
                default:
                  return false;
              }
              return itemDate >= filterDate;
            });
          });
        } else {
          const propertyName: keyof DocumentMetaData = field as keyof DocumentMetaData;
          filteredData = filteredData.filter((workItem) => selectedValues.includes(workItem[propertyName]));
        }
      });
    }
    this.workItems = filteredData;
  }

  parseCustomDate(dateString: string): Date | null {
		if (!dateString?.trim())
			return null;

		const [datePart, timePart] = dateString.trim().split(/\s+/);
		const format = this.userPreferedDateTimeformat;

		if (!format)
			return null;

		const dateSegments = datePart.split(/[-/]/).map(Number);
		if (dateSegments.length !== 3 || dateSegments.some(isNaN)) {
			return null;
		}

		let day: number, month: number, year: number;

		if (format.startsWith('dd/MM')) {
			[day, month, year] = dateSegments;
		} else if (format.startsWith('MM/dd')) {
			[month, day, year] = dateSegments;
		} else if (format.startsWith('yyyy/MM')) {
			[year, month, day] = dateSegments;
		} else {
			return null;
		}

		let hours = 0, minutes = 0, seconds = 0;

		if (timePart) {
			const t = timePart.split(':').map(Number);
			if (t.some(isNaN))
				return null;
			hours = t[0] ?? 0;
			minutes = t[1] ?? 0;
			seconds = t[2] ?? 0;
			if (hours > 23 || minutes > 59 || seconds > 59 || hours < 0 || minutes < 0 || seconds < 0) {
				return null;
			}
		}

		const date = new Date(year, month - 1, day, hours, minutes, seconds);
		return isNaN(date.getTime()) ? null : date;
	} 

  // Function to handle custom filter change event
  customClear(col:GridColumnHeader) {
    if(col.advancefilter.isAdvanceFilterUsed){
      this.clearCall(col);
    }
    this.filters[col.field] = [];
    this.customFilter(col.field);
  }

  // Function to Export the data to Excel
  exportToExcel(): void {
    this.retrievalService.exportToExcel(this.retrievalSearchFields).subscribe({
      next: (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });
        const dialogData: DialogData = {
          title: 'EXPORT TO EXCEL',
          message: "Data is getting downloaded...",
          showFinishButton: false,
          showOkButton: false,
          showCancelButton: true,
          showLoading: true,
        };
        const dialogRef = this.dialog.open(DialogComponent, {
          width: '600px',
          height: '160px',
          data: dialogData,
        });

        const fileName = 'Retrieval Data.xls';
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.commonService.showMessage('File downloaded successfully.', 'success');
        dialogRef.close();
      },
      error: (error) => {
        this.commonService.showMessage('Error while downloading excel file.', 'error');
      }
    });
  }

  // Function to handle the email modal
  showEmailModal(): void {
    if (!this.selectedWorkItems || !this.selectedWorkItems.length || !this.selectedWorkItems[0]?.DOCUMENT_ID) {
      return;
    }
    const data = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: this.globalVariable.getSelectedSystemId,
      id: this.selectedWorkItems[0].DOCUMENT_ID,
    };
    this.dialog.open(SendEmailComponent, {
      width: '600px',
      disableClose: true,
      data: data
    });
  }

  // Function to handle the copy link action
  copyLink(): void {
    if (!this.selectedWorkItems || !this.selectedWorkItems.length || !this.selectedWorkItems[0]?.DOCUMENT_ID) {
      return;
    }
    let message: string = "";
    this.retrievalService.getLink(
      this.globalVariable.getUserGPID,
      this.globalVariable.getSelectedSystemId,
      this.selectedWorkItems[0].DOCUMENT_ID
    ).subscribe({
      next: (response) => {
        navigator.clipboard.writeText(response).then(() => {
          message = "Link is copied. Link : " + response;
          this.commonService.showMessage(message, 'success');
        }).catch(err => {
          console.error('Failed to copy link: ', err);
        });
      },
      error: (error) => {
        console.error('Not able to fetch the link', error);
      }
    });
  }

  // Function to handle the view history
  showViewHistory(): void {
    if (!this.selectedWorkItems || !this.selectedWorkItems.length || !this.selectedWorkItems[0]?.DOCUMENT_ID) {
      return;
    }
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const documentId = this.selectedWorkItems[0].DOCUMENT_ID;
    this.retrievalService.getWorkflowHistory(userGpid, systemId, documentId).subscribe({
      next: (response: WorkflowHistoryResponse[]) => {
        this.dialog.open(WorkflowHistoryDialogComponent, {
          width: '85%',
          height: '485px',
          maxWidth: '100%',
          maxHeight: 'max-content',
          data: response
        });
      },
      error: (error) => {
        console.error('Failed to fetch workflow history:', error);
      }
    });
  }


  // Function to handle the document history
  showDocumentHistory(): void {
    if (!this.selectedWorkItems || !this.selectedWorkItems.length || !this.selectedWorkItems[0] || !this.selectedWorkItems[0].DOCUMENT_ID) {
      return;
    }
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const documentId = this.selectedWorkItems[0].DOCUMENT_ID;
    this.retrievalService.getDocumentHistory(userGpid, systemId, documentId).subscribe({
      next: (response: DocumentHistoryResponse) => {
        const dialogData = {
          documentId: documentId,
          batchId: response.batchId,
          createDate: response.createDate,
          docHistoryDtoList: response.docHistoryDtoList || []
        };
        this.dialog.open(DocumentHistoryDialogComponent, {
          width: '85%',
          height: '1060px',
          maxWidth: '100%',
          maxHeight: 'max-content',
          data: dialogData
        });
      },
      error: (error) => {
        console.error('Not able to fetch the document history:', error);
      }
    });
  }

  // Function to handle the view document notes
  showDocumentNotesAdmin(): void {
    if (!this.selectedWorkItems?.length) return;
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const DOCUMENT_ID = this.selectedWorkItems[0].DOCUMENT_ID;
    const dialogData = {
      DocumentId: DOCUMENT_ID,
      userGpid: userGpid,
      systemId: systemId,
      Type: 'viewandadd'
    };
    this.dialog.open(ViewAddDocNotesComponent, {
      width: '85%',
      maxWidth: '100%',
      data: dialogData
    });
  }

  showLineItemsGLEntry(): void {
    if (!this.selectedWorkItems?.length) return;
    const dialogData = {
      docId: this.selectedWorkItems[0].DOCUMENT_ID,
      abbyyDocId: this.selectedWorkItems[0].ABBYY_DOCUMENTID,
      abbyyBatchId: this.selectedWorkItems[0].ABBYY_BATCHID,
      isRetrieval: true,
    };
    this.dialog.open(LineItemsGlEntryComponent, {
      width: '85%',
      maxWidth: '100%',
      height:'auto',
      data: dialogData
    });
  }

  // Function to handle the view workflow notes
  showViewNotes(): void {
    if (!this.selectedWorkItems || !this.selectedWorkItems.length || !this.selectedWorkItems[0] || !this.selectedWorkItems[0].DOCUMENT_ID) {
      return;
    }
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const DOCUMENT_ID = this.selectedWorkItems[0].DOCUMENT_ID;
    const items = this.selectedWorkItems[0].INSTANCEID;
    const BatchId = this.selectedWorkItems[0].BATCHID;
    const dialogData = {
      DocumentId: DOCUMENT_ID,
      userGpid: userGpid,
      systemId: systemId,
      items: items,
      BatchId: BatchId,
      Type: 'view'
    };
    this.dialog.open(ViewWorkflowNotesComponent, {
      width: '85%',
      height: '600px',
      maxWidth: '100%',
      maxHeight: 'max-content',
      data: dialogData
    });
  }

  // Function to handle the Download Multi Select documents
  showMultiDocumentNotesAdmin(): void {
    if (!this.selectedWorkItems || !this.selectedWorkItems.length) {
      return;
    }
    const documentIds: string[] = this.selectedWorkItems.map(item => item.DOCUMENT_ID);
    const viewMultiDocumentRequest = {
      systemId: this.globalVariable.getSelectedSystemId,
      userGpid: this.globalVariable.getUserGPID,
      documentId: documentIds,
      isAttachment: false,
      isMerged: false
    };

    this.retrievalService.ViewMultiDocument(viewMultiDocumentRequest).subscribe({
      next: (response: Blob) => {
        const data = response;
        if (viewMultiDocumentRequest.isMerged) {
          // For merged PDF file
          const blob = new Blob([data], { type: 'application/pdf' });
          this.triggerFileDownload(blob, 'Retrieval Document.pdf');
        } else {
          // For ZIP file
          const blob = new Blob([data], { type: 'application/zip' });
          this.triggerFileDownload(blob, 'Retrieval Document.zip');
        }
        this.commonService.showMessage('Document downloaded successfully', 'success');
      },
      error: (error) => {
        this.commonService.showMessage('Error downloading file' + error.error.message, 'error');
      }
    });
  }

  // Function to trigger file download
  triggerFileDownload(blob: Blob, fileName: string): void {
    const elem = document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = fileName;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }

  // Function to handle the delete document
  deleteDocument(): void {
    let counter = 0;
    const dialogData: DialogData = {
      title: 'DELETE',
      message: 'Are you sure you want to delete?',
      showOkButton: true,
      showCancelButton: true,
    };
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '600px',
      height: '135px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'ok') {
        const guid = 'mcetoc_' + new Date().getTime().toString(32) + (counter++).toString(32);
        const documentIds: string[] = [];
        this.selectedWorkItems.forEach((item) => {
          documentIds.push(item.DOCUMENT_ID);
        });
 
        const deleteDocumentPayload = {
          systemId: this.globalVariable.getSelectedSystemId,
          userGpid: this.globalVariable.getUserGPID,
          documentId: documentIds,
          guid: guid,
        };
        this.retrievalService.deleteDocument(deleteDocumentPayload).subscribe({
          next: (response) => {
            if (response) {
              this.commonService.showMessage('Successfully deleted.', 'success');
              this.selectedWorkItems = this.selectedWorkItems.filter(item =>
                !documentIds.includes(item.DOCUMENT_ID)
              );
              this.workItems = this.workItems.filter(item =>
                !documentIds.includes(item.DOCUMENT_ID)
              );
              this.data = this.data.filter(item =>
                !documentIds.includes(item.DOCUMENT_ID)
              );
            } else {
              this.commonService.showMessage('Document not deleted', 'error');
            }
          },
          error: (error) => {
            this.commonService.showMessage('Error deleting document' + error.error.message, 'error');
          }
        });
      }
    });
  }

  
  applyCall(col:GridColumnHeader, filterCallback: any, filterRef: any){
    col.advancefilter.isAdvanceFilterUsed = true;
    this.applyAdvancedFilter(col);
    filterRef.hide();
  }

  applyAdvancedFilter(col: GridColumnHeader) {
    const field = col.field;
    const filterMeta = col.advancefilter;
    // Skip filtering if no constraints or filter not enabled
    if (!filterMeta?.isAdvanceFilterUsed || !filterMeta.constraints?.length) {
      return;
    }

    const constraints = filterMeta.constraints;
    const lastConstraint = constraints[constraints.length - 1];
    const operator = !lastConstraint || lastConstraint.value === null || lastConstraint.value === ''
      ? 'or' : filterMeta.operator || 'or';
    this.workItems = this.workItems.filter(row => {
      const rowValue = (row as any)[field];
      const results = constraints.map(constraint => {
        const filterValue = constraint.value;
        const matchMode = constraint.matchMode; 
        const stringValue = rowValue?.toString()?.toLowerCase?.();
        const filterString = filterValue?.toString()?.toLowerCase?.();
        switch (matchMode) { 
          case 'eq':
            return stringValue === filterString;
          case 'startswith':
            return stringValue?.startsWith(filterString);
          case 'contains':
            return stringValue?.includes(filterString);
          case 'doesnotcontain':
            return !stringValue?.includes(filterString);
          case 'endswith':
            return stringValue?.endsWith(filterString);

          // Date/number logic
          case 'gt':
            return new Date(rowValue) > new Date(filterValue);
          case 'gte':
            return new Date(rowValue) >= new Date(filterValue);
          case 'lt':
            return new Date(rowValue) < new Date(filterValue);
          case 'lte':
            return new Date(rowValue) <= new Date(filterValue);

          // Null checks
          case 'isnull':
            return rowValue == null || rowValue === '';
          case 'isnotnull':
            return rowValue != null && rowValue !== '';

          default:
            return true;
        }
      });
      return operator === 'or' ? results.some(r => r) : results.every(r => r);
    });
  }

  clearCall(col: GridColumnHeader, filterCallback?: any, filterRef?: any) {
    col.advancefilter.isAdvanceFilterUsed = false;
    col.advancefilter.constraints.forEach((c:ConstraintsModel) => {
      c.value = '';
    });
    this.workItems = this.data;
    if(filterCallback && filterRef){
      filterCallback(null);filterRef.hide();
    }
  }

  onDateRuleChange(event: any, field: string, index: number) {
    const value = event ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].value = value;
    }
  }

  onRuleChange(event: any, field: string, index: number) {
    const value = typeof event === 'string' ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].value = value;
    }
  }

  onMatchModeChange(event: any, field: string, index: number) {
    const mode = typeof event === 'string' ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].matchMode = mode;
    }
  }

  onOperatorChange(event: any, field: string) {
    const operator = typeof event === 'string' ? event : event.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.operator = operator;
    }
  }

  onCheckboxChange(index: number, type: string) {
    const group = this.searchFieldsArray.at(index) as FormGroup;
    if (type === 'yes' && group.get('yes')!.value) {
      group.get('no')!.setValue(false);
    } else if (type === 'no' && group.get('no')!.value) {
      group.get('yes')!.setValue(false);
    }
  }
} 
